var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
    [
      _c("div", { staticClass: "modal-content" }, [
        _c("div", { staticClass: "modal-header" }, [
          _c(
            "h5",
            { staticClass: "modal-title", attrs: { id: "exampleModalLabel" } },
            [_vm._t("default")],
            2
          ),
          _c("button", {
            staticClass: "btn-close",
            attrs: {
              type: "button",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
            },
            on: { click: _vm.clear },
          }),
        ]),
        _c("div", { staticClass: "modal-body" }, [
          _c("div", { staticClass: "mt-3" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "modifierName" } },
              [_vm._v("* Modifier Name")]
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.modifierName,
                  expression: "modifierName",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                id: "modifierName",
                placeholder: "Enter modifier name",
              },
              domProps: { value: _vm.modifierName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.modifierName = $event.target.value
                },
              },
            }),
          ]),
          _c("div", { staticClass: "form-check mt-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.adjustsPayment,
                  expression: "adjustsPayment",
                },
              ],
              staticClass: "form-check-input",
              attrs: { type: "checkbox", id: "adjustsPayment" },
              domProps: {
                checked: Array.isArray(_vm.adjustsPayment)
                  ? _vm._i(_vm.adjustsPayment, null) > -1
                  : _vm.adjustsPayment,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.adjustsPayment,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.adjustsPayment = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.adjustsPayment = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.adjustsPayment = $$c
                  }
                },
              },
            }),
            _c(
              "label",
              {
                staticClass: "form-check-label",
                attrs: { for: "addsToPrice" },
              },
              [_vm._v("Adds to Price")]
            ),
            _c(
              "button",
              {
                staticClass: "tooltip-btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.alertInfo()
                  },
                },
              },
              [_c("span", { staticClass: "question-mark" }, [_vm._v("?")])]
            ),
          ]),
          _c("div", { staticClass: "form-check mt-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.isMultiSelection,
                  expression: "isMultiSelection",
                },
              ],
              staticClass: "form-check-input",
              attrs: { type: "checkbox", id: "isMultiSelection" },
              domProps: {
                checked: Array.isArray(_vm.isMultiSelection)
                  ? _vm._i(_vm.isMultiSelection, null) > -1
                  : _vm.isMultiSelection,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.isMultiSelection,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.isMultiSelection = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.isMultiSelection = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.isMultiSelection = $$c
                  }
                },
              },
            }),
            _c(
              "label",
              {
                staticClass: "form-check-label",
                attrs: { for: "isMultiSelection" },
              },
              [_vm._v("Multi-Selection")]
            ),
          ]),
          _c("div", { staticClass: "form-check mt-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.isRequired,
                  expression: "isRequired",
                },
              ],
              staticClass: "form-check-input",
              attrs: { type: "checkbox", id: "isRequired" },
              domProps: {
                checked: Array.isArray(_vm.isRequired)
                  ? _vm._i(_vm.isRequired, null) > -1
                  : _vm.isRequired,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.isRequired,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.isRequired = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.isRequired = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.isRequired = $$c
                  }
                },
              },
            }),
            _c(
              "label",
              { staticClass: "form-check-label", attrs: { for: "isRequired" } },
              [_vm._v("Is Required")]
            ),
          ]),
          _c("div", { staticClass: "form-check mt-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.isItemSpecific,
                  expression: "isItemSpecific",
                },
              ],
              staticClass: "form-check-input",
              attrs: { type: "checkbox", id: "isItemSpecific" },
              domProps: {
                checked: Array.isArray(_vm.isItemSpecific)
                  ? _vm._i(_vm.isItemSpecific, null) > -1
                  : _vm.isItemSpecific,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.isItemSpecific,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.isItemSpecific = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.isItemSpecific = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.isItemSpecific = $$c
                  }
                },
              },
            }),
            _c(
              "label",
              {
                staticClass: "form-check-label",
                attrs: { for: "isItemSpecific" },
              },
              [_vm._v("Is item Specific")]
            ),
            _vm.isItemSpecific
              ? _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedItem,
                        expression: "selectedItem",
                      },
                    ],
                    staticClass: "form-select",
                    attrs: { id: "dropdown" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedItem = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.itemList, function (item, index2) {
                    return _c(
                      "option",
                      {
                        key: index2,
                        staticClass: "card mx-3",
                        domProps: { value: item._id },
                      },
                      [_vm._v(_vm._s(item.name))]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c(
                "label",
                { staticClass: "form-label", attrs: { for: "answers" } },
                [_vm._v("*Modifier Answers")]
              ),
              _vm._l(_vm.answer_list, function (answer, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "input-group mb-3" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: answer.text,
                          expression: "answer.text",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Enter answer text" },
                      domProps: { value: answer.text },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(answer, "text", $event.target.value)
                        },
                      },
                    }),
                    _vm.adjustsPayment
                      ? _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: answer.cost,
                              expression: "answer.cost",
                            },
                          ],
                          staticClass: "form-control ms-2",
                          attrs: {
                            type: "text",
                            placeholder: "Enter answer text",
                          },
                          domProps: { value: answer.cost },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(answer, "cost", $event.target.value)
                            },
                          },
                        })
                      : _vm._e(),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.removeAnswer(index)
                          },
                        },
                      },
                      [_vm._v(" Remove ")]
                    ),
                  ]
                )
              }),
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-primary",
                  attrs: { type: "button" },
                  on: { click: _vm.addAnswer },
                },
                [_vm._v(" Add Answer ")]
              ),
            ],
            2
          ),
          _vm.canSubmit
            ? _c(
                "div",
                {
                  staticClass: "btn-group float-right mt-4",
                  attrs: { role: "group" },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      attrs: { type: "button", "data-bs-dismiss": "modal" },
                      on: { click: _vm.save },
                    },
                    [_vm._v(" Save ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary mx-3",
                      attrs: { type: "button", "data-bs-dismiss": "modal" },
                      on: { click: _vm.clear },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "btn-group float-right mt-4",
                  attrs: { role: "group" },
                },
                [
                  _vm._m(0),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary mx-3",
                      attrs: { type: "button", "data-bs-dismiss": "modal" },
                      on: { click: _vm.clear },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                ]
              ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tooltip-wrapper" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-success",
          attrs: { type: "button", disabled: "" },
        },
        [_vm._v(" Save ")]
      ),
      _c("span", { staticClass: "tooltip-text" }, [
        _vm._v("Please complete form"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }